import { useState } from "react";
import type { EditorFeatureAttrs } from "../editorTypes";

interface ReviewPanelProps {
  attrs: EditorFeatureAttrs;
  busy: boolean;
  onEnviarRevisao: () => void;
  onAprovar: () => void;
  onRejeitar: (motivo: string) => void;
  onSolicitarAjuste: (motivo: string) => void;
  onPublicar: () => void;
}

export default function ReviewPanel({
  attrs,
  busy,
  onEnviarRevisao,
  onAprovar,
  onRejeitar,
  onSolicitarAjuste,
  onPublicar,
}: ReviewPanelProps) {
  const [motivo, setMotivo] = useState("");

  if (!attrs.rascunhoId) {
    return (
      <div className="p-3 border-t border-background-100 text-[11px] text-foreground-400">
        Salve a feição como rascunho para habilitar o fluxo de revisão.
      </div>
    );
  }

  const status = attrs.status;

  return (
    <div className="p-3 border-t border-background-100 space-y-2">
      <p className="text-[11px] font-semibold text-foreground-500 uppercase tracking-wide mb-1">Fluxo de revisão</p>

      {(status === "RASCUNHO" || status === "AJUSTAR") && (
        <button
          onClick={onEnviarRevisao}
          disabled={busy}
          className="w-full text-xs font-medium px-3 py-2 rounded-md bg-blue-500 text-white hover:bg-blue-600 disabled:opacity-50 cursor-pointer"
        >
          Enviar para revisão
        </button>
      )}

      {status === "EM_REVISAO" && (
        <>
          <button
            onClick={onAprovar}
            disabled={busy}
            className="w-full text-xs font-medium px-3 py-2 rounded-md bg-green-500 text-white hover:bg-green-600 disabled:opacity-50 cursor-pointer"
          >
            Aprovar
          </button>
          <textarea
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Motivo (para rejeitar ou solicitar ajuste)"
            rows={2}
            className="w-full text-xs px-2 py-1.5 border border-background-200 rounded-md resize-none"
          />
          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={() => onSolicitarAjuste(motivo)}
              disabled={busy}
              className="text-xs font-medium px-3 py-2 rounded-md bg-caution-100 text-caution-700 hover:bg-caution-200 disabled:opacity-50 cursor-pointer"
            >
              Solicitar ajuste
            </button>
            <button
              onClick={() => onRejeitar(motivo)}
              disabled={busy}
              className="text-xs font-medium px-3 py-2 rounded-md bg-danger-100 text-danger-700 hover:bg-danger-200 disabled:opacity-50 cursor-pointer"
            >
              Rejeitar
            </button>
          </div>
        </>
      )}

      {status === "APROVADO" && (
        <button
          onClick={onPublicar}
          disabled={busy}
          className="w-full text-xs font-medium px-3 py-2 rounded-md bg-primary-500 text-white hover:bg-primary-600 disabled:opacity-50 cursor-pointer"
        >
          Publicar
        </button>
      )}

      {status === "PUBLICADO" && <p className="text-[11px] text-green-700 bg-green-50 rounded px-2 py-1.5">Já publicado.</p>}
      {status === "REJEITADO" && <p className="text-[11px] text-danger-700 bg-danger-50 rounded px-2 py-1.5">Rejeitado.</p>}
    </div>
  );
}
